"use client"

import { ClipboardCheckIcon, LinkIcon } from "lucide-react"
import { useState } from "react"
import { toast } from "sonner"
import { Button } from "@/components/ui/button"

interface CopyPageLinkProps {
  url: string
}

export function CopyPageLink({ url }: CopyPageLinkProps) {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setIsCopied(true)
    } catch (error) {
      toast.error("Failed to copy link. Please try again.")
    }
  }

  return (
    <Button type="button" onClick={handleCopy} variant="ghost" size="xs">
      {isCopied ? <ClipboardCheckIcon /> : <LinkIcon />}
      Copy Link
    </Button>
  )
}
